import { selectDepreciation } from '../../../../redux/features/selectors/depreciationSelectors.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { RootState } from '../../../../redux/types.ts';
import {
  DepreciateSeparatelyModalContentPriceRow,
  DepreciateSeparatelyModalContentPriceRowWrapper,
} from './DepreciateSeparatelyModalContentPriceRow.tsx';
import { TotalSeparateDepreciationCalculationTooltipText } from './TotalSeparateDepreciationCalculationTooltipText.tsx';

export const DepreciateSeparatelyModalContentTotalDepreciation = ({
  activeId,
}: {
  activeId: string;
}) => {
  const totalDepreciation = useAppSelector((state: RootState) =>
    selectDepreciation(state, activeId),
  );

  return (
    <DepreciateSeparatelyModalContentPriceRowWrapper>
      <DepreciateSeparatelyModalContentPriceRow
        title="Total Depreciation"
        informationTooltip={<TotalSeparateDepreciationCalculationTooltipText activeId={activeId} />}
        price={totalDepreciation}
      />
    </DepreciateSeparatelyModalContentPriceRowWrapper>
  );
};
